import { render, staticRenderFns } from "./emptyHint.vue?vue&type=template&id=24d04265"
import script from "./emptyHint.vue?vue&type=script&lang=ts"
export * from "./emptyHint.vue?vue&type=script&lang=ts"
import style0 from "./emptyHint.vue?vue&type=style&index=0&id=24d04265&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports